<template>
    <div class="footer-widget footer-widget-links" :class="className">
        <h1 v-if="items.title">{{items.title}}</h1>
        <ul>
            <li v-for="(item, i) in items.links" :key="i">
                <router-link :to="item.url">{{item.title}}</router-link>
            </li>
        </ul>
    </div>
</template>


<script>
export default {
    name: 'FooterLinksWidgets',
    props: ['items', 'className'],
    data() {
        return {

        }
    }
}
</script>